import { portalNavItems, fleetNavItems } from '../../data/settings-nav-items'
import { useDispatch, useSelector } from 'react-redux'
import { selectSettings, setCurrentPage } from '../../reducers/settings'
import { selectUser } from '../../reducers/users'
import { getRoles, permitsRole } from '../../utils/roles'
import { IconChevronLeft } from '@tabler/icons-react'
import { useNavigate } from 'react-router-dom'
import { getPage } from '../../utils/navigation'
import { navType } from '../../data/nav-items'

function SettingsNavMenu() {
  const { currentPage, orgHasDemoData } = useSelector(selectSettings)
  const { session } = useSelector(selectUser)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const roles = getRoles(session)

  const filteredProfileNavItems = portalNavItems
    .filter((nav) => roles && permitsRole(roles, nav.roles))
    .filter((nav) => orgHasDemoData || nav.type !== 'DEMO_DATA')

  const filteredFleetNavItems = fleetNavItems.filter((nav) => roles && permitsRole(roles, nav.roles))

  const passAdditionalRequirements = (item: navType) => {
    if (item.additionalRequirements) {
      for (let i = 0; i < item.additionalRequirements.length; i++) {
        switch (item.additionalRequirements[i]) {
          case 'customDnsSettingsEnabled':
            if (!session?.portalPreferences?.customDnsSettingsEnabled) {
              return false
            }
            break
        }
      }
    }
    return true
  }

  return (
    <>
      {/* Nav menu */}
      <div className="w-[220px] h-full bg-mainBackground  border-r border-mainBorder pl-8">
        <div className="flex mt-8">
          <div
            onClick={() => {
              const value = localStorage.getItem('DASHBOARD_PAGE_COOKIE')
              navigate(getPage(value || 'DASHBOARD'))
            }}
            role="button"
          >
            <IconChevronLeft className="h-6 w-6 text-mainText mr-2.5 mt-0.5" />
          </div>
          <p className="text-mainText text-lg font-semibold">Settings</p>
        </div>
        <div className="w-[190px] mt-8">
          {filteredProfileNavItems.length > 0 && (
            <>
              <p className="text-neutral-10 text-xs leading-none tracking-tight font-semibold mb-1">Portal</p>
              {filteredProfileNavItems.map((item) => (
                <>
                  {!passAdditionalRequirements(item) ? null : (
                    <p
                      key={item.type}
                      role="button"
                      className={`w-[190px] ${currentPage === item.type ? 'text-mainPurple dark:text-secondaryPurple' : 'text-mainText'} justify-start cursor-pointer mt-3 font-medium`}
                      onClick={() => {
                        dispatch(setCurrentPage(item.type))
                        localStorage.setItem('SETTINGS_PAGE_COOKIE', item.type)
                      }}
                    >
                      {item.display}
                    </p>
                  )}
                </>
              ))}
            </>
          )}

          <p className="text-neutral-10 text-xs leading-none tracking-tight font-semibold mt-8">Fleet Management</p>
          {filteredFleetNavItems.map((item) => (
            <>
              {!passAdditionalRequirements(item) ? null : (
                <p
                  key={item.type}
                  role="button"
                  className={`w-[190px] ${currentPage === item.type ? 'text-mainPurple dark:text-secondaryPurple' : 'text-mainText'} justify-start cursor-pointer mt-3 font-medium`}
                  onClick={() => {
                    dispatch(setCurrentPage(item.type))
                    localStorage.setItem('SETTINGS_PAGE_COOKIE', item.type)
                  }}
                >
                  {item.display}
                </p>
              )}
            </>
          ))}
        </div>
      </div>
    </>
  )
}

export default SettingsNavMenu
